module.exports = __webpack_public_path__ + "static/media/buy_start_service_teach_4.e8fbbe49.jpg";